<template>
    <div class="order_content">
        <div class="tabs_content">
            <ul>
                <li class="active">订货单</li>
                <li @click="orderjump">退货单</li>
            </ul>
        </div>
        <div class="order_box">
            <div class="order_search_content">
                <div class="order_search_list">
                    <Input v-model="pclikename" search enter-button="搜索" placeholder="订单号/商品名称" @on-search="searchClick" style="width: 212px;" />
                </div>
                <div class="order_search_list">
                    <Select v-model="status" clearable style="width: 148px;" placeholder="订单状态" @on-change="searchClick">
                        <Option v-for="(item, index) in statuslist" :key="index" :value="index">{{item}}</Option>
                    </Select>
                </div>
                <div class="order_search_list">
                    <Select v-model="fundstatus" clearable style="width: 148px;" placeholder="付款状态" @on-change="searchClick">
                        <Option v-for="(item, index) in fundstatuslist" :key="index" :value="index">{{item}}</Option>
                    </Select>
                </div>
                <div class="order_search_list">
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="stardatetiem" placeholder="开始时间" @on-change="starChange" style="width: 148px;"></DatePicker>
                    <span class="order_search_spacer">~</span>
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="enddatetiem" placeholder="结束时间" @on-change="endChange" style="width: 148px;"></DatePicker>
                </div>
            </div>
            <div class="order_table_content">
                <Table
                    border
                    ref="selection"
                    :loading="tloading"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
            <!-- 分页 -->
            <div class="page_content">
                <Page
                    :total="pagetotal"
                    :current="pagecurrent"
                    :page-size="pagesize"
                    :page-size-opts="pagesizeopts"
                    show-total
                    show-sizer
                    show-elevator
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
export default {
    props: ['searchsign', 'searchname'],
    data() {
        return {
            tloading: false, // 表格加载中
            thead: [ // 表格头部
                {
                    width: 340,
                    title: '单号',
                    key: 'ordernumber',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_number'
                                    },
                                    [
                                        h('span', params.row.orderdno),
                                        h('span', params.row.addtime),
                                    ]
                                )
                    }
                },
                {
                    title: '金额 (元)',
                    key: 'allcost'
                },
                {
                    title: '收货人',
                    key: 'consignee',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_name'
                                    },
                                    [
                                        h('span', params.row.takegoodsname),
                                        h('span', params.row.takegoodsphone)
                                    ]
                                )
                    }
                },
                {
                    title: '订单状态',
                    key: 'statusname',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            color: params.row.status != 4 && params.row.status != 5 && params.row.status != 6 ? '#FF8000' : ''
                                        }
                                    },
                                    params.row.statusname
                                )
                    }
                },
                {
                    title: '付款状态',
                    key: 'fundstatusname',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            color: params.row.fundstatus != 4 && params.row.fundstatus != 5 ? '#FF8000' : ''
                                        }
                                    },
                                    params.row.fundstatusname
                                )
                    }
                },
                {
                    title: '操作',
                    key: 'operation',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_operation'
                                    },
                                    [
                                        h('span',
                                            {
                                                on: {
                                                    click: () => {
                                                        this.detailsClick(params.row.id)
                                                    }
                                                },
                                            },
                                            '详情'
                                        ),
                                        h('span',
                                            {
                                                on: {
                                                    click: () => {
                                                        this.paymentClick(params.row.id)
                                                    }
                                                },
                                            },
                                            params.row.waitcost > 0 && params.row.fundstatus < 5 && params.row.status != 5 && params.row.reback != 2 || params.row.waitcost > 0 && params.row.fundstatus < 5 && params.row.status != 5 && params.row.reback != 3 ? '付款' : ''
                                        )
                                    ]
                                )
                    }
                }
            ],
            goodslist: [], // 表格列表 status: 0 待审核 1 待出库 2 待发货 3 待收货 4 已完成 5 已取消 6 退款成功 fundstatus: 0 待付款 1 待确认 2 部分收款 4 已收款 5 已取消
            pclikename: '', // 订单号/商品名称
            status: '', // 订单状态
            statuslist: {}, // 订单状态
            fundstatus: '', // 付款状态
            fundstatuslist: {}, // 付款状态
            stardatetiem: '', // 开始时间
            enddatetiem: '', // 结束时间
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取订单信息
            if (!this.$store.state.openmall) {
                this.tloading = true
                this.http.post(api.orderlist,
                    {
                        pclikename: this.pclikename,
                        status: this.status,
                        fundstatus: this.fundstatus,
                        starttime: this.stardatetiem,
                        endtime: this.enddatetiem,
                        page: this.pagecurrent,
                        pagesize: this.pagesize,
                    }
                )
                .then(response => {
                    console.log(response)
                    if (!response.data.error) {
                        this.goodslist = response.data.msg.orderlist
                        this.statuslist = response.data.msg.status
                        this.fundstatuslist = response.data.msg.fundstatus
                        // 获取商品分页
                        this.pagetotal = response.data.msg.order_pagecontent.num
                    } else {
                        this.$Message.warning(response.data.msg)
                    }
                    this.tloading = false
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        orderjump () { // 跳转链接
            this.$router.push({
                path: '/OrderReturn'
            })
        },
        detailsClick (id) { // 订单详情
            this.$router.push({
                name: '订货详情',
                params: {
                    id: id
                }
            })
        },
        paymentClick (id) { // 付款
            this.$router.push({
                name: '支付',
                params: {
                    type: 0,
                    id: id
                }
            })
        },
        searchClick () { // 点击搜索按钮
            this.pagecurrent = 1
            this.getInfo()
        },
        starChange (e) { // 搜索订单开始时间
            if (e > this.enddatetiem && this.enddatetiem != '') {
                this.$Message.warning('开始时间不能大于结束时间')
            } else if (this.enddatetiem != '') {
                this.stardatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.stardatetiem = e
            }
        },
        endChange (e) { // 搜索订单结束时间
            if (e < this.stardatetiem && this.stardatetiem != '') {
                this.$Message.warning('结束时间不能小于开始时间')
                this.enddatetiem = ''
            } else if (this.stardatetiem != '') {
                this.enddatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.enddatetiem = e
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
        searchinfo () { // 搜索
            if (this.searchsign == 'order') {
                this.pclikename = this.searchname
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.getInfo()
            }
        }
    },
    created () {
        if (this.$route.params.statetype != undefined) {
            if (this.$route.params.statetype == 'waitpay') {
                this.fundstatus = this.$route.params.statetype
            } else {
                this.status = this.$route.params.statetype
            }
        }
        this.searchinfo()
    },
    watch: {
        searchname () {
            this.searchinfo()
        },
        '$router.statetype' (val) {
            console.log(val)
            // 待付款 nopayinfo

            // 待发货 status2info
            // 待收货 status3info

        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/order/order.vue